import React from "react";
import userImg from "../../Assets/Photos/user-photo.jpeg";
import { FaQuoteLeft, FaStar } from "react-icons/fa";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const ClientsReview = () => {
  const responsive = {
    desktop: { breakpoint: { max: 4000, min: 1024 }, items: 2 },
    tablet: { breakpoint: { max: 1024, min: 600 }, items: 2 },
    mobile: { breakpoint: { max: 600, min: 0 }, items: 1 },
  };

  const reviews = [
    {
      name: "Nishad Ahmed",
      title: "Managing Director, TechCraft Ltd.",
      image: userImg,
      text: "Working with this team was an absolute pleasure. Their attention to detail, responsiveness, and dedication exceeded our expectations. We saw immediate improvements in both efficiency and customer satisfaction.",
    },
    {
      name: "Sadia Rahman",
      title: "Senior Software Engineer, CodeHive",
      image: userImg,
      text: "They delivered a top-notch product ahead of schedule. The communication was clear, and their problem-solving skills were impressive. I would definitely collaborate with them again.",
    },
    {
      name: "Farzana Haque",
      title: "Marketing Lead, PixelEdge Agency",
      image: userImg,
      text: "Their team truly understands user experience. The solution they developed has transformed the way we engage with our customers online. It’s clean, fast, and extremely user-friendly.",
    },
    {
      name: "Razwan Chowdhury",
      title: "CEO, Infinity Retail",
      image: userImg,
      text: "From planning to deployment, the experience was seamless. They grasped our business goals quickly and translated them into a highly functional system. Post-launch support has also been excellent.",
    },
    {
      name: "Nusrat Jahan",
      title: "Founder, EduMentor",
      image: userImg,
      text: "I was amazed by their professionalism and creativity. They not only met our technical requirements but also suggested valuable improvements. Our platform is now more scalable and intuitive than ever.",
    },
  ];

  const renderStars = (count = 5) =>
    Array.from({ length: count }, (_, i) => (
      <FaStar key={i} className="text-yellow-500" />
    ));

  return (
    <div className="py-10 bg-base-200">
      <div className="mx-auto max-w-6xl px-5 lg:px-0">
        <div className="text-center mb-6">
          <h1 className="text-4xl font-bold mb-3">
            Our Clients Simply Love Our Work
          </h1>
          <p className="text-gray-400">
            Our services are appreciated by our clients from all across the
            globe for high quality and impressive results.
          </p>
        </div>

        <Carousel
          responsive={responsive}
          infinite
          autoPlay
          autoPlaySpeed={4000}
          showDots
          removeArrowOnDeviceType={["desktop", "tablet", "mobile"]}
          className="pb-8"
        >
          {reviews.map((review, index) => (
            <div
              key={index}
              className="bg-base-100 p-5 mx-2 rounded-md shadow-sm"
            >
              <div className="flex my-5 text-justify">
                <FaQuoteLeft className="text-xl text-gray-400 mr-3" />
                <p className="text-gray-300">{review.text}</p>
              </div>
              <div className="flex items-center gap-4">
                <img
                  src={review.image}
                  alt={review.name}
                  loading="lazy"
                  className="rounded-full w-16 h-16 bg-gray-400"
                />
                <div>
                  <p className="text-xl font-semibold">{review.name}</p>
                  <p className="text-gray-400">{review.title}</p>
                  <div className="flex gap-1 mt-2">{renderStars()}</div>
                </div>
              </div>
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  );
};

export default ClientsReview;
